import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
    return (
        <main className="min-h-[calc(100vh-4rem)] flex flex-col items-center justify-center px-6 text-center">
            <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ 404</p>
            <h1 className="font-display font-extrabold text-6xl md:text-9xl tracking-tighter uppercase leading-none">
                Off <span className="text-brand-saffron italic font-serif-editorial">runway.</span>
            </h1>
            <p className="text-white/60 mt-6 max-w-md">
                This page doesn't exist yet — or maybe it never will. Head back and discover something worth wearing.
            </p>
            <div className="mt-8 flex gap-3">
                <Link to="/">
                    <Button className="bg-brand-saffron text-black hover:bg-brand-saffron/90 font-semibold rounded-md px-8 py-6 text-base">
                        Home
                    </Button>
                </Link>
                <Link to="/discover">
                    <Button variant="outline" className="border-white/30 text-white bg-transparent hover:bg-white/10 font-semibold rounded-md px-8 py-6 text-base">
                        Discover brands
                    </Button>
                </Link>
            </div>
        </main>
    );
}
